import React, { useEffect } from "react";
import { useCommercialContent } from "../hooks/useCommercialContents"
import ContactForm from "../components/ContactUs";
import CommercialSection from "../components/CommercialSection";
import { trackPageView, getSessionId, getUserId } from "../utils/pageTracking";
import { useImages } from "../hooks/useImages";

const GUIDS = {
    help: '8fb0f356-a66d-46ab-95ca-847c1270ab1b'  
} 

const CommercialPage: React.FC = () => {
    const {
        helpContent,
        smallBusinessContent,
        largerBusinessContent
    } = useCommercialContent();

    const commercialImage = useImages(GUIDS.help)?.image;

    useEffect(() => {
        // Track page view
        trackPageView('Commercial', getSessionId(), getUserId());
        
        // Scroll to top when page loads
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="pt-16 min-h-screen bg-[#c3d3ab] text-gray-800">
            <div className="relative w-full">
                <img
                    src={commercialImage}
                    alt="Commercial"
                    className="w-full h-auto max-h-[70vh] object-cover"
                />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-8 bg-white shadow-md rounded max-w-md mx-auto text-center">
                    <h1 className="text-3xl sm:text-5xl font-mono text-orange-600">
                        Commercial<br />Accounts
                    </h1>
                </div>
            </div>
            <div className="flex flex-col items-center justify-center text-center">
                {helpContent && (
                    <CommercialSection
                        heading={helpContent.heading}
                        content={helpContent.content}
                        className="mt-12 max-w-3xl"
                        headingClassName="font-mono whitespace-normal sm:whitespace-nowrap font-bold underline text-2xl sm:text-3xl md:text-4xl mb-2"
                    // contentTextSize="text-xl"
                    />
                )}
                {smallBusinessContent && (
                    <CommercialSection
                        heading={smallBusinessContent.heading}
                        content={smallBusinessContent.content}
                        headingClassName="font-mono font-bold underline text-xl sm:text-2xl md:text-3xl mb-2"
                        className="max-w-3xl"
                    />
                )}
                {largerBusinessContent && (
                    <CommercialSection
                        heading={largerBusinessContent.heading}
                        content={largerBusinessContent.content}
                        headingClassName="font-mono font-bold underline text-xl sm:text-2xl md:text-3xl  mb-2"
                        className="max-w-3xl mb-12"
                    />
                )}
            </div>
           
                <ContactForm
                    showPhone={false}
                    showSubject={false}
                    subjectText="Commercial Inquiry"
                    headingText="Let's Work Together"
                    headingClassName="text-start"
                    subText="Get in touch so we can start working together"
                    twoColumn={true}
                    socialIcons={true}
                ></ContactForm>
          
        </section>
    )
}

export default CommercialPage
